// import 'bootstrap';
import './jquery/lsag.lazysizes';
import './jquery/lsag.bootstrap';
if (!document.getElementsByTagName("body")[0].hasAttribute("data-ispreviewmode")) {
    require('./angular/app.js');
} else {
    console.debug(`### smartedit active, don't boot angular ###`);
}
import './jquery/lsag.breakpoints';
import './jquery/lsag.historyService';
import './jquery/lsag.stickyHeader';
import './jquery/lsag.offcanvas';
import './jquery/lsag.mainnavigation';
import './jquery/lsag.refinements';
// import './jquery/lsag.masonry';
import './jquery/lsag.footer';
import './jquery/lsag.paginationsort';
import './jquery/lsag.pagination';
import './jquery/lsag.scrollup';
import './jquery/lsag.select2';
import './jquery/lsag.select2Pos';
import './jquery/lsag.productimageslider';
import './jquery/lsag.productcarouselcomponent';
import './jquery/lsag.search';
import './jquery/lsag.tabs';
import './jquery/lsag.checkout.address';
import './jquery/lsag.checkout.deliverymode';
import './jquery/lsag.overviewRow';
import './jquery/lsag.trackingProductClick';
import './jquery/lsag.preventCopyPaste';
import './jquery/lsag.review';
import './jquery/lsag.ezplus';
import './jquery/lsag.imask';
import './jquery/lsag.jobFinder';
import './jquery/lsag.storeFinder';
import './jquery/lsag.algolia';
import './jquery/lsag.smallpromobanner';
import './jquery/lsag.storeSelector';
import './jquery/lsag.intersections';
import './jquery/lsag.stripe';
